{
	"main": {
		"title": "Glider flights",
		"subtitle1": "GLIDER AIRCRAFT DATA",
		"subtitle2": "TOW PLANE DATA",
		"subtitle3": "GENERAL DATA",
		"nazaj": "Back"
	},
	"nav": {
		"vnos": "Input",
		"zapisi": "Records"
	},
	"labels": {
		"pilotJ": "Select glider pilot:",
		"instruktor": "Select glider instructor:",
		"registracijaJ": "Select glider registration:",
		"namenJ": "Select purpose:",
		"nalogaJ": "Select glider flight task:",
		"pilotM": "Select tow plane pilot:",
		"registracijaM": "Select tow plane registration:",
		"vzlet": "Select takeoff:",
		"pristanek": "Select landing:",
		"poletanje": "Takeoff:",
		"odklop": "Release:",
		"nezakljucen": "Incomplete flight?",
		"pristanekJ": "Glider landing:",
		"pristanekM": "Tow plane landing:",
		"opomba": "Note",
		"novIcao": "Enter ICAO code",
		"dodajLetalisce": "Add an airport",
		"opozorilo": "For towing, enter the time in the \"Takeoff\" field when the aircraft begins to move with the tow rope attached in preparation for takeoff.\nIn the \"Tow Plane Landing\" field, enter the time when the aircraft comes to a complete stop after landing."
	},
	"buttons": {
		"brisiIzbiro": "Clear selection",
		"vnesiZapis": "Enter record",
		"dodajLetalisce": "Add"
	},
	"obvestila": {
	  "brisiSredstvo": "Are you sure you want to delete the asset?",
	  "vnosUspesen": "Entry successful. Please update the logbook accordingly for this entry.",
	  "vnosLetaliscaUspesen": "Entry successful.",
	  "vnosNeuspesen": "Error retrieving data.",
	  "nepricakovanaNapaka": "An unexpected error occurred",
	  "napakaBranja": "Error reading data.",
	  "napakaBranjaNezakljuceni": "Error reading data (unfinished flights).",
	  "napakaBranjaCasVleke": "Error reading data (tow time).",
	  "poslano": "Message sent",
	  "niPoslano": "Message was not sent",
	  "zapisPrihodnost": "The record contains a date in the future. CORRECT the selected date!",
	  "zapisCasPrihodnost": "One or more entries contain a time in the future. Check the times!",
	  "zapisCasNapaka": "Record times are incorrect! Check the times again!",
	  "zapisDodan": "Record successfully added! Please update the logbook accordingly for this entry.",
	  "zapisNapaka": "Error entering data",
	  "zapisNapakaMotorno": "Error entering data (motor tow).",
	  "napakaInputa": "Input error. Fields marked in red are required! Check that all fields are filled in!",
	  "napakaDodajanjaLetalisca": "There was an error entering the airport",
	  "letalisceNiNajdeno": "The ICAO airport code was not found in the database"
	}
}